import myPeekavilleLogo from './images/myPeekaville-logo.png';
import AppleAppStoreBadge from './components/AppleAppStoreBadge';
import GooglePlayStoreBadge from './components/PlayStoreBadge';
import InfoSegment from './InfoSegment';
import Footer from './Footer';
import styles from './SCSS/AppDownloadRedirect.module.scss';
import appStyles from './SCSS/App.module.scss';
import { getCookie, setCookie } from './GlobalFunctions';

const AppDownloadRedirect = () => {
  return (
    <>
      <div className={styles.background}>
        <div className={styles.messageBox}>
          <img
            className={styles.logo}
            src={myPeekavilleLogo}
            alt='myPeekapakville Logo'
          />
          <div className={styles.paragraphContainer}>
            <p className={styles.paragraph}>
              It looks like you're trying to access myPeekaville from a mobile
              device or tablet. For the best experience, please go to the App
              Store or Google Play to download myPeekaville.
            </p>
          </div>
          <div className={styles.buttonsContainer}>
            <AppleAppStoreBadge />
            <GooglePlayStoreBadge />
          </div>
          <span className={appStyles.textLink} onClick={onClickDesktopVersion}>
            Go to desktop site instead
          </span>
          <span
            className={appStyles.textLink}
            onClick={onClickNativeAppVersion}
          >
            Open native app
          </span>
        </div>
      </div>
      <InfoSegment id='nextSegment' />
      <Footer />
    </>
  );

  function onClickDesktopVersion() {
    setCookie('peekapak.preferDesktopSite', 'true', 365);
    window.location.reload();
  }

  function onClickNativeAppVersion() {
    const provider = getCookie('peekapak.idP');
    window.location.href = `${getLoginUrl(provider || 'Clever')}`;
  }

  function getLoginUrl(providerName: string): string {
    const [appClientId, authCognitoDomainPrefix] = (() => {
      if (import.meta.env.MODE === 'development') {
        // App client ID, found under App Client Setting
        return ['78jmkvkfna9tep99akje8mkif9', 'dev-auth']; // Found under App Integration -> Domain Name. Changing this means it must be updated in all linked Social providers redirect and javascript origins
      } else {
        return ['7mke1jkv7r9h6kuhm0a4dd0jtc', 'auth']; // Found under App Integration -> Domain Name. Changing this means it must be updated in all linked Social providers redirect and javascript origins
      }
    })();

    const redirectUrl = 'https://applinks.peekapak.com';
    const cognitoAuthUrl = '.peekapak.com';

    // DOCS: https://docs.aws.amazon.com/cognito/latest/developerguide/login-endpoint.html
    const loginUrl =
      `https://${authCognitoDomainPrefix}${cognitoAuthUrl}` +
      `/oauth2/authorize?response_type=code&client_id=${appClientId}` +
      `&redirect_uri=${encodeURIComponent(redirectUrl)}` +
      `&identity_provider=${providerName}` +
      `&scope=phone+email+profile+openid+aws.cognito.signin.user.admin`;

    return loginUrl;
  }
};

export default AppDownloadRedirect;
